export const formStructure = [
  [
    {
      name: 'tipoDepot',
      label: 'Tipo Depot',
      placeholder: 'Ex: Entrega ou Coleta',
      component: 'SearchSelect',
      type: 'search',
      colProps: { md: 3 },
      options: [
        { value: 'entrega', label: 'Entrega' },
        { value: 'coleta', label: 'Coleta' },
      ],
    },
    {
      name: 'numeroContainer',
      label: 'Nº Container',
      placeholder: 'Digite o número do container',
      component: 'FormField',
      type: 'text',
      colProps: { md: 3 },
    },
    {
      name: 'tipoContainer',
      label: 'Tipo Container',
      placeholder: 'Ex: 20DC, 40HC, 40RH',
      component: 'SearchSelect',
      type: 'search',
      colProps: { md: 3 },
      options: [
        { value: '20DC', label: '20DC' },
        { value: '40DC', label: '40DC' },
        { value: '40H', label: '40H' },
        { value: '40HC', label: '40HC' },
        { value: '40RH', label: '40RH' },
      ],
    },
    {
      name: 'referenciaCliente',
      label: 'Referência Cliente',
      placeholder: 'Digite a Referência cliente',
      component: 'FormField',
      type: 'text',
      colProps: { md: 3 },
    },
  ],
  [
    {
      name: 'statusPedido',
      label: 'Status Pedido',
      colProps: { md: 3 },
      placeholder: 'Status do pedido',
      component: 'SearchSelect',
      type: 'search',
      options: [
        { value: 'OK', label: 'OK' },
        { value: 'PENDENTE', label: 'PENDENTE' },
      ],
    },
    {
      name: 'status',
      label: 'Status',
      placeholder: 'Selecione o status',
      colProps: { md: 3 },
      component: 'SearchSelect',
      type: 'search',
      options: [
        { value: 'coleta_no_porto', label: 'COLETA PORTO' },
        { value: 'baixado_aguardando_cheio_barra_velha', label: 'BX CHEIO BV' },
        { value: 'baixado_aguardando_cheio_itapoa', label: 'BX CHEIO ITA' },
        { value: 'baixado_aguardando_vazio_barra_velha', label: 'BX VAZIO BV' },
        { value: 'baixado_aguardando_vazio_itapoa', label: 'BX VAZIO ITA' },
        { value: 'finalizado', label: 'FINALIZADO' },
      ],
    },
  ],
  [
    {
      name: 'localColeta',
      label: 'Local de Coleta',
      placeholder: 'Digite o local de coleta',
      component: 'FormField',
      type: 'text',
      colProps: { md: 4 },
    },
    {
      name: 'dataColeta',
      label: 'Data Coleta',
      placeholder: 'Selecione a data da coleta',
      component: 'DatePickers',
      type: 'datetime',
      colProps: { md: 3 },
    },
  ],
  [
    {
      name: 'local',
      label: 'Local de Entrega',
      placeholder: 'Digite o local de entrega',
      component: 'FormField',
      type: 'text',
      colProps: { md: 4 },
    },
    {
      name: 'dataEntrega',
      label: 'Data Entrega',
      placeholder: 'Selecione a data da entrega',
      component: 'DatePickers',
      type: 'datetime',
      colProps: { md: 3 },
    },
  ],
  [
    {
      name: 'localDevolucao',
      label: 'Local Devolução',
      placeholder: 'Digite o local de devolução',
      component: 'FormField',
      type: 'text',
      colProps: { md: 4 },
    },
    {
      name: 'dataDevolucao',
      label: 'Data Devolução',
      placeholder: 'Selecione a data de devolução',
      component: 'DatePickers',
      type: 'datetime',
      colProps: { md: 3 },
    },
  ],
  [
    {
      name: 'freeTime',
      label: 'Free Time',
      placeholder: 'Data de free time',
      component: 'DatePickers',
      type: 'datetime',
      colProps: { md: 3 },
    },
  ],

  // ==========================
  // COLETA (Motorista / Veiculo / Carreta)
  // ==========================
  [
    {
      name: 'motoristaColetaNome',
      label: 'Motorista Coleta',
      placeholder: 'Buscar motorista de coleta',
      component: 'SearchSelect',
      type: 'search',
      colProps: { md: 3 },
      readOnly: false,
      disabled: false,
    },
    {
      name: 'motoristaColetaCpf',
      label: 'CPF',
      placeholder: 'CPF do motorista',
      component: 'FormField',
      type: 'text',
      colProps: { md: 3 },
      readOnly: true,
      disabled: true,
    },
  ],
  [
    {
      name: 'idVeiculoColeta',
      label: 'Frota Veículo Coleta',
      placeholder: 'Buscar frota do veículo de coleta',
      component: 'SearchSelect',
      type: 'search',
      colProps: { md: 3 },
    },
    {
      name: 'veiculoColetaPlaca',
      label: 'Placa Veículo Coleta',
      placeholder: 'Placa do veículo de coleta',
      component: 'FormField',
      type: 'text',
      colProps: { md: 3 },
      readOnly: true,
      disabled: true,
    },
  ],
  [
    {
      name: 'idCarretaColeta',
      label: 'Frota Carreta Coleta',
      placeholder: 'Buscar frota da carreta de coleta',
      component: 'SearchSelect',
      type: 'search',
      colProps: { md: 3 },
    },
    {
      name: 'carretaColetaPlaca',
      label: 'Placa Veículo Coleta',
      placeholder: 'Placa da carreta de coleta',
      component: 'FormField',
      type: 'text',
      colProps: { md: 3 },
      readOnly: true,
      disabled: true,
    },
  ],

  // ==========================
  // ENTREGA (Motorista / Veiculo)
  // ==========================
  [
    {
      name: 'motoristaEntregaNome',
      label: 'Motorista Entrega',
      placeholder: 'Buscar motorista de entrega',
      component: 'SearchSelect',
      type: 'search',
      colProps: { md: 3 },
      readOnly: false,
      disabled: false,
    },
    {
      name: 'motoristaEntregaCpf',
      label: 'CPF',
      placeholder: 'CPF do motorista',
      component: 'FormField',
      type: 'text',
      colProps: { md: 3 },
      readOnly: true,
      disabled: true,
    },
  ],
  [
    {
      name: 'idVeiculoEntrega',
      label: 'Frota Veículo Entrega',
      placeholder: 'Buscar frota do veículo de entrega',
      component: 'SearchSelect',
      type: 'search',
      colProps: { md: 3 },
    },
    {
      name: 'veiculoEntregaPlaca',
      label: 'Placa Veículo Entrega',
      placeholder: 'Placa do veículo de entrega',
      component: 'FormField',
      type: 'text',
      colProps: { md: 3 },
      readOnly: true,
      disabled: true,
    },
  ],

  // ==========================
  // DEVOLUCAO (Motorista / Veiculo)
  // ==========================
  [
    {
      name: 'motoristaDevolucaoNome',
      label: 'Motorista Devolução',
      placeholder: 'Buscar motorista de devolução',
      component: 'SearchSelect',
      type: 'search',
      colProps: { md: 3 },
      readOnly: false,
      disabled: false,
    },
    {
      name: 'motoristaDevolucaoCpf',
      label: 'CPF',
      placeholder: 'CPF do motorista',
      component: 'FormField',
      type: 'text',
      colProps: { md: 3 },
      readOnly: true,
      disabled: true,
    },
  ],
  [
    {
      name: 'IdVeiculoDevolucao',
      label: 'Frota Veículo Devolução',
      placeholder: 'Buscar frota do veículo de devolução',
      component: 'SearchSelect',
      type: 'search',
      colProps: { md: 3 },
    },
    {
      name: 'veiculoDevolucaoPlaca',
      label: 'Placa Veículo Devolução',
      placeholder: 'Placa do veículo de devolução',
      component: 'FormField',
      type: 'text',
      colProps: { md: 3 },
      readOnly: true,
      disabled: true,
    },
  ],

  [
    {
      name: 'motDepot',
      label: 'Responsável Depot',
      placeholder: 'Motivo ou responsável no depot',
      component: 'FormField',
      type: 'text',
      colProps: { md: 12 },
    },
  ],
  [
    {
      name: 'observacao',
      label: 'Observação',
      placeholder: 'Observações do pedido',
      component: 'FormField',
      type: 'textarea',
      colProps: { md: 12 },
    },
  ],
  [
    {
      name: 'anotacoesProgramacao',
      label: 'Anotações de Programação',
      placeholder: 'Observações da programação',
      component: 'FormField',
      type: 'textarea',
      colProps: { md: 12 },
    },
  ],
  [
    {
      name: 'anotacoesOperacionais',
      label: 'Anotações Operacionais',
      placeholder: 'Observações operacionais',
      component: 'FormField',
      type: 'textarea',
      colProps: { md: 12 },
    },
  ],
];

export const formSections = (initialValues = {}) => [
  {
    title: `DETALHES DO CONTAINER ${initialValues.numeroContainer || ''}`,
    rows: [0, 1],
  },
  {
    title: 'LOCAIS E DATAS',
    rows: [2, 3, 4, 5],
  },
  {
    title: 'COLETA (MOTORISTA / VEÍCULO / CARRETA)',
    rows: [6, 7, 8],
  },
  {
    title: 'ENTREGA (MOTORISTA / VEÍCULO)',
    rows: [9, 10],
  },
  {
    title: 'DEVOLUÇÃO (MOTORISTA / VEÍCULO)',
    rows: [11, 12],
  },
  {
    title: 'ANOTAÇÕES',
    rows: [13, 14, 15, 16],
  },
];

export const validateForm = (values) => {
  const errors = {};
  const requiredFields = [
    'tipoDepot',
    'numeroContainer',
    'tipoContainer',
    'referenciaCliente',
    'statusPedido',
    'status',
    'localColeta',
    'local',
    'localDevolucao',
    'dataColeta',
    'dataEntrega',
    'freeTime',
  ];

  requiredFields.forEach((field) => {
    const value = values?.[field];
    const isEmptyString = typeof value === 'string' && value.trim().length === 0;
    if (value === null || value === undefined || value === '' || isEmptyString) {
      errors[field] = 'Campo obrigatório';
    }
  });

  return errors;
};
